<ng-container *ngIf="user"> <greco-user-video-gallery [user]="user"></greco-user-video-gallery> </ng-container>
